var _path, _path2, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInserAbove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.5C6.75329 3.5 2.5 7.75329 2.5 13C2.5 18.2467 6.75329 22.5 12 22.5C17.2467 22.5 21.5 18.2467 21.5 13C21.5 7.75329 17.2467 3.5 12 3.5ZM1 13C1 6.92487 5.92487 2 12 2C18.0751 2 23 6.92487 23 13C23 19.0751 18.0751 24 12 24C5.92487 24 1 19.0751 1 13Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0.75C2 0.335786 2.33579 0 2.75 0H21.25C21.6642 0 22 0.335786 22 0.75C22 1.16421 21.6642 1.5 21.25 1.5H2.75C2.33579 1.5 2 1.16421 2 0.75Z",
    fill: "#111111"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_392_12224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8998 8.2998C12.1569 8.2998 12.3654 8.50822 12.3654 8.76532V12.3343H15.9344C16.1915 12.3343 16.3999 12.5427 16.3999 12.7998C16.3999 13.0569 16.1915 13.2653 15.9344 13.2653H12.3654V16.8343C12.3654 17.0914 12.1569 17.2998 11.8998 17.2998C11.6427 17.2998 11.4343 17.0914 11.4343 16.8343V13.2653H7.86542C7.60832 13.2653 7.3999 13.0569 7.3999 12.7998C7.3999 12.5427 7.60832 12.3343 7.86542 12.3343H11.4343V8.76532C11.4343 8.50822 11.6427 8.2998 11.8998 8.2998Z",
    fill: "#111111"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_392_12224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(7.3999 8.2998)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInserAbove);
export default __webpack_public_path__ + "static/media/inser-above.e4887490.svg";
export { ForwardRef as ReactComponent };